var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.081 3.303a.98.98 0 0 0-.855-.489l-15.077.011a.99.99 0 0 0-.93.646.984.984 0 0 0 .063.836l.002.004.002.003c.054.089.123.172.206.246l5.739 4.948 1.399 7.43a.965.965 0 0 0 .808.785c.409.065.811-.128 1.021-.483l7.617-12.948-.17-.294h.001l.17.294a.976.976 0 0 0 .004-.99Zm-.685-.193-.17-.296.17.296ZM9.093 8.067 4.916 4.46h10.496L9.093 8.067Zm1.833 6.83-1.018-5.41 6.332-3.612-5.314 9.022Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0ba99cc410690f8c77939ff15d8d46ad.svg";
export { ForwardRef as ReactComponent };